<template>
    <div>
        <div v-if=candidate class="container text-start mt-3 px-3" style="text-align: justify !important" >
            <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#data" aria-expanded="true" aria-controls="collapseOne">
                            <b>A. &nbsp; &nbsp; PERSONAL DATA</b>
                        </button>
                    </h2>
                    <div id="data" class="accordion-collapse collapse show">
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="row">A.1</th>
                                        <td colspan="3" class="text-break"><b>Name:</b> {{ candidate.name }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.2</th>
                                        <td colspan="3" class="text-break"><b>(SP. No.):</b> {{ candidate.fileNum }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.3</th>
                                        <td colspan="5"><b>Present status, grade level, and salary:</b></td>
                                    </tr>
                                    <tr v-if="candidate.presentStatus">
                                        <th scope="row"></th>
                                        <td colspan="5" class="text-break">{{ candidate.presentStatus }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.4</th>
                                        <td colspan="3" class="text-break"><b>Faculty:</b> {{ candidate.faculty }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.5</th>
                                        <td colspan="3" class="text-break"><b>Department:</b> {{ candidate.department }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.6</th>
                                        <td colspan="5">
                                            <b>
                                                Date, Status of Level of First
                                                Appointment in this University:
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.firstEmployment">
                                        <th scope="row"></th>
                                        <td colspan="5" class="text-break">
                                            {{ candidate.firstEmployment }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.7</th>
                                        <td colspan="5">
                                            <b>
                                                Last change in status in this University
                                                with date:
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.lastEmployment">
                                        <th scope="row"></th>
                                        <td colspan="5" class="text-break">
                                            {{ candidate.lastEmployment }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.8</th>
                                        <td colspan="5">
                                            <b>
                                                Reference and date of notification
                                                concerning any more recent
                                                consideration of change in status:
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.statusNotification">
                                        <th scope="row"></th>
                                        <td colspan="5" class="text-break">
                                            {{ candidate.statusNotification }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">A.9</th>
                                        <td colspan="4" class="text-break">
                                            <b>
                                                Date of confirmation of appointment:
                                            </b>
                                            {{ candidate.confirmationDate ?
                                                candidate.confirmationDate.split("-").reverse().join('/') : '' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#qualifications" aria-expanded="false" aria-controls="collapseTwo">
                            <b>B. &nbsp; &nbsp;  QUALIFICATIONS</b>
                        </button>
                    </h2>
                    <div id="qualifications" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="row">B.1</th>
                                        <td colspan="4">
                                            <b>
                                                Doctorate, if any (with date and
                                                awarding body):
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.doctorate">
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">
                                            {{ candidate.doctorate.data }}
                                        </td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || !certifierIsExternal" scope="col" colspan="1">
                                            <select 
                                                v-model="candidate.doctorate.score"
                                                @change="scoreItem('doctorate', null, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=5>5</option>
                                                <option value=10>10</option>
                                                <option value=30>30</option>
                                                <option value=60>60</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">B.2</th>
                                        <td colspan="4">
                                            <b>
                                                Master’s degree, if any (with date and
                                                awarding body):
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.masters">
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">
                                            {{ candidate.masters.data }}
                                        </td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || !certifierIsExternal" scope="col" colspan="1">
                                            <select 
                                                v-model="candidate.masters.score"
                                                @change="scoreItem('masters', null, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=25>25</option>
                                                <option value=45>45</option>
                                                <option value=70>70</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">B.3</th>
                                        <td colspan="4">
                                            <b>
                                                Other relevant academic or professional qualifications:
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-for="qualification, qualificationIndex in candidate.otherQualifications">
                                        <td>({{ qualificationIndex + 1 }})</td>
                                        <td colspan="3" class="text-break">
                                            {{ qualification.data }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#publications" aria-expanded="false" aria-controls="collapseTwo">
                            <b>C. &nbsp; &nbsp;  PUBLICATIONS AND OTHER PRODUCTIVE WORKS</b>
                        </button>
                    </h2>
                    <div id="publications" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <!--research books-->
                                    <tr>
                                        <th scope="col">C.1</th>
                                        <th scope="col" colspan="4">Research books (in main discipline): </th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.books && certifierIsAssessor) ? candidate.academicStaff.books.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all books:</b> &nbsp;
                                            <select @change="scoreItem('books', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="book, bookIndex in candidate.academicStaff.books">
                                        <td scope="col">({{ bookIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ book.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="booksScoring && (itemToScore == bookIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!booksScoring" v-model="candidate.academicStaff.books[bookIndex].score"
                                                @change="scoreItem('books', bookIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--major productive works-->
                                    <tr>
                                        <th scope="col">C.2</th>
                                        <th scope="col" colspan="5">Major other productive work:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.majorWorks && certifierIsAssessor) ? candidate.academicStaff.majorWorks.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all major productive works:</b> &nbsp;

                                            <select @change="scoreItem('majorWorks', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="majorWork, majorWorkIndex in candidate.academicStaff.majorWorks">
                                        <td scope="col">({{ majorWorkIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ majorWork.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="majorWorksScoring && (itemToScore == majorWorkIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!majorWorksScoring"
                                                v-model="candidate.academicStaff.majorWorks[majorWorkIndex].score"
                                                @change="scoreItem('majorWorks', majorWorkIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--minor productive works-->
                                    <tr>
                                        <th scope="col">C.3</th>
                                        <th scope="col" colspan="5">Minor other productive work:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.minorWorks && certifierIsAssessor) ? candidate.academicStaff.minorWorks.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all minor productive works:</b> &nbsp;
                                            <select @change="scoreItem('minorWorks', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="minorWork, minorWorkIndex in candidate.academicStaff.minorWorks">
                                        <td scope="col">({{ minorWorkIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ minorWork.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="minorWorksScoring && (itemToScore == minorWorkIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!minorWorksScoring"
                                                v-model="candidate.academicStaff.minorWorks[minorWorkIndex].score"
                                                @change="scoreItem('minorWorks', minorWorkIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--Research books-->
                                    <tr>
                                        <th scope="col">C.4</th>
                                        <th scope="col" colspan="5">Chapters in research books:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.bookChapters && certifierIsAssessor) ? candidate.academicStaff.bookChapters.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all book chapters:</b> &nbsp;
                                            <select @change="scoreItem('bookChapters', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="bookChapter, bookChapterIndex in candidate.academicStaff.bookChapters">
                                        <td scope="col">({{ bookChapterIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ bookChapter.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="bookChaptersScoring && (itemToScore == bookChapterIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!bookChaptersScoring"
                                                v-model="candidate.academicStaff.bookChapters[bookChapterIndex].score"
                                                @change="scoreItem('bookChapters', bookChapterIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--Journal papers-->
                                    <tr>
                                        <th scope="col">C.5</th>
                                        <th scope="col" colspan="5">Refereed Published Journal Papers:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.journalArticles && certifierIsAssessor) ? candidate.academicStaff.journalArticles.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all journal articles:</b> &nbsp;
                                            <select @change="scoreItem('journalArticles', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="journalArticle, journalArticleIndex in candidate.academicStaff.journalArticles">
                                        <td scope="col">({{ journalArticleIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ journalArticle.data }}</td>
                                        <td scope="col" colspan="1">
                                            <router-link :to='"/viewer?src=" + journalArticle.fileUrl'><button class="btn btn-outline-secondary"><i class="fa-solid fa-eye"></i></button></router-link>
                                        </td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <select
                                                v-model="candidate.academicStaff.journalArticles[journalArticleIndex].score"
                                                @change="scoreItem('journalArticles', journalArticleIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--Conference papers-->
                                    <tr>
                                        <th scope="col">C.6</th>
                                        <th scope="col" colspan="5">Refereed Published Conference Papers:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.conferenceArticles && certifierIsAssessor) ? candidate.academicStaff.conferenceArticles.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all conference articles:</b> &nbsp;
                                            <select @change="scoreItem('conferenceArticles', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="conferenceArticle, conferenceArticleIndex in candidate.academicStaff.conferenceArticles">
                                        <td scope="col">({{ conferenceArticleIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ conferenceArticle.data }}</td>
                                        <td scope="col" colspan="1">
                                            <router-link :to='"/viewer?src=" + conferenceArticle.fileUrl'><button class="btn btn-outline-secondary"><i class="fa-solid fa-eye"></i></button></router-link>
                                        </td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="conferenceScoring && (itemToScore == conferenceArticleIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!conferenceScoring"
                                                v-model="candidate.academicStaff.conferenceArticles[conferenceArticleIndex].score"
                                                @change="scoreItem('conferenceArticles', conferenceArticleIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <!--Technical Reports-->
                                    <tr>
                                        <th scope="col">C.7</th>
                                        <th scope="col" colspan="5">Technical/Technological Reports/Monographs:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.technicalReports && certifierIsAssessor) ? candidate.academicStaff.technicalReports.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all reports:</b> &nbsp;
                                            <select @change="scoreItem('technicalReports', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="technicalReport, technicalReportIndex in candidate.academicStaff.technicalReports">
                                        <td scope="col">({{ technicalReportIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ technicalReport.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="technicalReportScoring && (itemToScore == technicalReportIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!technicalReportScoring"
                                                v-model="candidate.academicStaff.technicalReports[technicalReportIndex].score"
                                                @change="scoreItem('technicalReports', technicalReportIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <!--Editorship-->
                                    <tr>
                                        <th scope="col">C.8</th>
                                        <th scope="col" colspan="5">Editorship of research books:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.bookEditors && certifierIsAssessor) ? candidate.academicStaff.bookEditors.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all editorship of research books:</b> &nbsp;
                                            <select @change="scoreItem('bookEditors', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="bookEditor, bookEditorIndex in candidate.academicStaff.bookEditors">
                                        <td scope="col">({{ bookEditorIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ bookEditor.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="bookEditorScoring && (itemToScore == bookEditorIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!bookEditorScoring"
                                                v-model="candidate.academicStaff.bookEditors[bookEditorIndex].score"
                                                @change="scoreItem('bookEditors', bookEditorIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!--Other books in discipline-->
                                    <tr>
                                        <th scope="col">C.9</th>
                                        <th scope="col" colspan="5">Other books in discipline:</th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.otherBooks && certifierIsAssessor) ? candidate.academicStaff.otherBooks.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="5">
                                            <b>Score all other books:</b> &nbsp;
                                            <select @change="scoreItem('otherBooks', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="otherBook, otherBookIndex in candidate.academicStaff.otherBooks">
                                        <td scope="col">({{ otherBookIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ otherBook.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="otherBookScoring && (itemToScore == otherBookIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!otherBookScoring"
                                                v-model="candidate.academicStaff.otherBooks[otherBookIndex].score"
                                                @change="scoreItem('otherBooks', otherBookIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#experience" aria-expanded="true" aria-controls="collapseOne">
                            <b>D. &nbsp; &nbsp;  TEACHING AND PROFESSIONAL EXPERIENCE</b>
                        </button>
                    </h2>
                    <div id="experience" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="col">D.1</th>
                                        <th scope="col" colspan="4">Full-time Post-Masters teaching in a University or at an
                                            equivalent
                                            level
                                            (give dates, employers, post held): </th>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            Sessions taught: {{ candidate.academicStaff.sessionsTaught }} session(s)
                                        </td>
                                    </tr>
                                    <tr v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="3">
                                            <b>Score all teaching per session:</b> &nbsp;
                                            <select v-model="candidate.academicStaff.teachingScore"
                                                @change="scoreItem('teachings', 'all', $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                                <option value=2.5>2.5</option>
                                                <option value=3>3</option>
                                                <option value=3.5>3.5</option>
                                                <option value=4>4</option>
                                                <option value=4.5>4.5</option>
                                                <option value=5>5</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <!--pg teaching-->
                                    <tr v-if="candidate.academicStaff.pgTeachings ? candidate.academicStaff.pgTeachings.length > 0 : false">
                                        <th scope="col"></th>
                                        <th scope="col" colspan="2">Postgraduate teaching: </th>
                                    </tr>
                                    <tr v-for="pgTeaching, pgTeachingIndex in candidate.academicStaff.pgTeachings">
                                        <td scope="col">({{ pgTeachingIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ pgTeaching.data }}</td>
                                    </tr>

                                    <!--ug teaching-->
                                    <tr v-if="candidate.academicStaff.ugTeachings ? candidate.academicStaff.ugTeachings.length > 0 : false">
                                        <th scope="col"></th>
                                        <th scope="col" colspan="2">Undergraduate teaching: </th>
                                    </tr>
                                    <tr v-for="ugTeaching, ugTeachingIndex in candidate.academicStaff.ugTeachings">
                                        <td scope="col">({{ ugTeachingIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ ugTeaching.data }}</td>
                                    </tr>

                                    <!--professional experience-->
                                    <tr>
                                        <th scope="col">D.2</th>
                                        <th scope="col" colspan="4">Relevant professional experience in Industry or appropriate
                                            non-teaching/research
                                            institution (give dates, employer, and post held):
                                        </th>
                                    </tr>
                                    <tr
                                        v-for="professionalExperience, professionalExperienceIndex in candidate.academicStaff.professionalExperiences">
                                        <td scope="col">({{ professionalExperienceIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ professionalExperience.data }}</td>
                                    </tr>

                                    <!--Degree programs-->
                                    <tr>
                                        <th scope="col">D.3</th>
                                        <th scope="col" colspan="4">Specify any degree programs development work, participation
                                            in major seminars, supervision of graduate level and post-graduate work, or other
                                            teaching/
                                            professional experience you consider relevant, especially since appointment/last
                                            change of grading in this university:

                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col">(a)</th>
                                        <th scope="col" colspan="4">Degree Programmes Development Work:</th>
                                    </tr>
                                    <tr v-for="degreeProgram, degreeProgramIndex in candidate.academicStaff.degreePrograms">
                                        <td scope="col">({{ degreeProgramIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ degreeProgram.data }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">(b)</th>
                                        <th scope="col" colspan="4">Participation in Major Seminars and Workshops:</th>
                                    </tr>
                                    <tr v-for="seminarWorkshop, seminarWorkshopIndex in candidate.academicStaff.seminarWorkshops">
                                        <td scope="col">({{ seminarWorkshopIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ seminarWorkshop.data }}</td>
                                    </tr>
                                    <!--pg supervision-->
                                    <tr>
                                        <th scope="col">(c)</th>
                                        <th scope="col" colspan="4">Supervision of Postgraduate Theses:</th>
                                    </tr>

                                    <tr v-if="(candidate.academicStaff.pgSupervisions && certifierIsAssessor) ? candidate.academicStaff.pgSupervisions.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="3">
                                            <b>Score all postgraduate supervisions:</b> &nbsp;
                                            <select @change="scoreItem('pgSupervisions', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <tr v-for="pgSupervision, pgSupervisionIndex in candidate.academicStaff.pgSupervisions">
                                        <td scope="col">({{ pgSupervisionIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ pgSupervision.data }}</td>

                                        <td scope="col" class="text-end">
                                            <div class="spinner"
                                                v-if="pgSupervisionScoring && (itemToScore == pgSupervisionIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!pgSupervisionScoring"
                                                v-model="candidate.academicStaff.pgSupervisions[pgSupervisionIndex].score"
                                                @change="scoreItem('pgSupervisions', pgSupervisionIndex, $event.target.value)">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                                <option value=2>2</option>
                                            </select>
                                        </td>

                                    </tr>

                                    <!--ug supervision-->
                                    <tr>
                                        <th scope="col">(d)</th>
                                        <th scope="col" colspan="4">Supervision of Undergraduate Theses:</th>
                                    </tr>

                                    <tr v-if="(candidate.academicStaff.ugSupervisions && certifierIsAssessor) ? candidate.academicStaff.ugSupervisions.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="3">
                                            <b>Score all undergraduate supervisions:</b> &nbsp;
                                            <select @change="scoreItem('ugSupervisions', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <tr v-for="ugSupervision, ugSupervisionIndex in candidate.academicStaff.ugSupervisions">
                                        <td scope="col">({{ ugSupervisionIndex + 1 }})</td>
                                        <td scope="col" :colspan="certifierIsAssessor ? 2 : 3" class="text-break">{{ ugSupervision.data }}</td>

                                        <td scope="col" class="text-end">
                                            <div class="spinner"
                                                v-if="ugSupervisionScoring && (itemToScore == ugSupervisionIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!ugSupervisionScoring"
                                                v-model="candidate.academicStaff.ugSupervisions[ugSupervisionIndex].score"
                                                @change="scoreItem('ugSupervisions', ugSupervisionIndex, $event.target.value)">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                                <option value=1>1</option>
                                                <option value=1.5>1.5</option>
                                            </select>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#conferences" aria-expanded="false" aria-controls="collapseTwo">
                            <b>E. &nbsp; &nbsp;  CONFERENCES AND LEARNED SOCIETY ACTIVITIES</b>
                        </button>
                    </h2>
                    <div id="conferences" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <!--conferences-->
                                    <tr v-if="candidate.academicStaff.conferences ? candidate.academicStaff.conferences.length > 0 : false">
                                        <th scope="col">E.1</th>
                                        <th scope="col" colspan="4">Conferences attended and paper read (but not included in C.6
                                            above), with dates, since joining this University): </th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.conferences && certifierIsAssessor) ? candidate.academicStaff.conferences.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="4">
                                            <b>Score all conferences attended:</b> &nbsp;
                                            <select @change="scoreItem('conferences', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="conference, conferenceIndex in candidate.academicStaff.conferences">
                                        <td scope="col">({{ conferenceIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ conference.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="conferencesScoring && (itemToScore == conferenceIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!conferencesScoring"
                                                v-model="candidate.academicStaff.conferences[conferenceIndex].score"
                                                @change="scoreItem('conferences', conferenceIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                            </select>
                                        </td>
                                    </tr>

                                    <!-- professional bodies-->
                                    <tr v-if="candidate.professionalBodies ? candidate.professionalBodies.length > 0 : false">
                                        <th scope="col">E.2</th>
                                        <th scope="col" colspan="4">Active membership of relevant professional bodies: </th>
                                    </tr>
                                    <tr v-if="(candidate.professionalBodies && certifierIsAssessor) ? candidate.professionalBodies.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="4">
                                            <b>Score all professional body membership:</b> &nbsp;
                                            <select @change="scoreItem('professionalBodies', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=0.5>0.5</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="professionalBody, professionalBodyIndex in candidate.professionalBodies">
                                        <td scope="col">({{ professionalBodyIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ professionalBody.data }}</td>
                                        <td v-if="certifierIsAssessor || certifierIsPanel || certifierIsExternal" scope="col" colspan="1">
                                            <div class="spinner"
                                                v-if="professionalBodyScoring && (itemToScore == professionalBodyIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <select v-if="!professionalBodyScoring"
                                                v-model="candidate.professionalBodies[professionalBodyIndex].score"
                                                @change="scoreItem('professionalBodies', professionalBodyIndex, $event.target.value)"
                                                :disabled="certifierIsPanel">
                                                <option value=0 selected>0</option>
                                                <option value=0.5>0.5</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#uniadmin" aria-expanded="false" aria-controls="collapseTwo">
                            <b>F. &nbsp; &nbsp;  UNIVERSITY ADMINISTRATION</b>
                        </button>
                    </h2>
                    <div id="uniadmin" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <!--university admin-->
                                    <tr>
                                        <th scope="col">F.1</th>
                                        <th scope="col" colspan="2">
                                            Deanship, Directorship, Coordinatorship, Headship, in this
                                            University, with
                                            dates
                                        </th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.universityAdmins && certifierIsAssessor) ? candidate.academicStaff.universityAdmins.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="2">
                                            <b>Score all:</b> &nbsp;
                                            <select @change="scoreItem('universityAdmins', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=1>1</option>
                                                <option value=3>3</option>
                                                <option value=5>5</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="universityAdmin, universityAdminIndex in candidate.academicStaff.universityAdmins">
                                        <td scope="col">({{ universityAdminIndex + 1 }})</td>
                                        <td scope="col" class="text-break">{{ universityAdmin.data }}</td>
                                        <td scope="col" style="width: 180px">
                                            <div class="spinnersession"
                                                v-if="universityAdminScoring && (itemToScore == universityAdminIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <div class="text-end">
                                                <span v-if="!universityAdminScoring">
                                                    <span class="mt-1">
                                                        {{ universityAdmin.sessionNum }} session(s)
                                                    </span>
                                                    &nbsp;
                                                    <span class="mt-1">
                                                        x
                                                    </span>
                                                    &nbsp;
                                                    <select class="score"
                                                        v-model="candidate.academicStaff.universityAdmins[universityAdminIndex].score"
                                                        @change="scoreItem('universityAdmins', universityAdminIndex, $event.target.value)">
                                                        <option value=0 selected>0</option>
                                                        <option value=1>1</option>
                                                        <option value=3>3</option>
                                                        <option value=5>5</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- committee membership-->
                                    <tr
                                        v-if="candidate.committeeMemberships ? candidate.committeeMemberships.length > 0 : false">
                                        <th scope="col">F.2</th>
                                        <th scope="col" colspan="2">Committee membership: </th>
                                    </tr>
                                    <tr
                                        v-if="(candidate.committeeMemberships && certifierIsAssessor) ? candidate.committeeMemberships.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="4">
                                            <b>Score all committee membership:</b> &nbsp;
                                            <select @change="scoreItem('committeeMemberships', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="committeeMembership, committeeMembershipIndex in candidate.committeeMemberships">
                                        <td scope="col">({{ committeeMembershipIndex + 1 }})</td>
                                        <td scope="col" class="text-break">{{ committeeMembership.data }}</td>
                                        <td scope="col">
                                            <div class="spinnersession"
                                                v-if="committeeMembershipScoring && (itemToScore == committeeMembershipIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <div class="text-end">
                                                <span v-if="!committeeMembershipScoring">
                                                    <span class="mt-1">
                                                        {{ committeeMembership.sessionNum }} session(s)
                                                    </span>
                                                    &nbsp;
                                                    <span class="mt-1">
                                                        x
                                                    </span>
                                                    &nbsp;
                                                    <select class="score"
                                                        v-model="candidate.committeeMemberships[committeeMembershipIndex].score"
                                                        @change="scoreItem('committeeMemberships', committeeMembershipIndex, $event.target.value)">
                                                        <option value=0 selected>0</option>
                                                        <option value=1>1</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- other services-->
                                    <tr v-if="candidate.academicStaff.otherServices ? candidate.academicStaff.otherServices.length > 0 : false">
                                        <th scope="col">F.3</th>
                                        <th scope="col" colspan="2">Hall Mastership/Student Advisory/SIWES/Laboratory
                                            Organization/ Other
                                            internal University Services, in this University with dates:
                                        </th>
                                    </tr>
                                    <tr v-if="(candidate.academicStaff.otherServices && certifierIsAssessor) ? candidate.academicStaff.otherServices.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="2">
                                            <b>Score all other University services:</b> &nbsp;
                                            <select @change="scoreItem('otherServices', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=1>1</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="otherService, otherServiceIndex in candidate.academicStaff.otherServices">
                                        <td scope="col">({{ otherServiceIndex + 1 }})</td>
                                        <td scope="col" class="text-break">{{ otherService.data }}</td>
                                        <td scope="col">
                                            <div class="spinnersession"
                                                v-if="otherServiceScoring && (itemToScore == otherServiceIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <div class="text-end">
                                                <span v-if="!otherServiceScoring">
                                                    <span class="mt-1">
                                                        {{ otherService.sessionNum }} session(s)
                                                    </span>
                                                    &nbsp;
                                                    <span class="mt-1">
                                                        x
                                                    </span>
                                                    &nbsp;
                                                    <select class="score"
                                                        v-model="candidate.academicStaff.otherServices[otherServiceIndex].score"
                                                        @change="scoreItem('otherServices', otherServiceIndex, $event.target.value)">
                                                        <option value=0 selected>0</option>
                                                        <option value=1>1</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#community" aria-expanded="false" aria-controls="collapseTwo">
                            <b>G. &nbsp; &nbsp;  COMMUNITY SERVICE</b>
                        </button>
                    </h2>
                    <div id="community" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <!--community services-->
                                    <tr>
                                        <th scope="col">G.1</th>
                                        <th scope="col" colspan="4">Give details (e.g. research extension work, service on
                                            public bodies, membership of socio-cultural groups, editorship of learned journals
                                            public lectures, radio or TV talks, service to learned and professional bodies,
                                            publications outside main field etc.):
                                        </th>
                                    </tr>

                                    <tr v-if="(candidate.communityServices && certifierIsAssessor) ? candidate.communityServices.length > 0 : false">
                                        <td></td>
                                        <td class="text-end" scope="col" colspan="4">
                                            <b>Score all community services:</b> &nbsp;
                                            <select @change="scoreItem('communityServices', 'all', $event.target.value)">
                                                <option value=0></option>
                                                <option value=0>0</option>
                                                <option value=1>1</option>
                                                <option value=2>2</option>
                                                <option value=3>3</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr v-for="communityService, communityServiceIndex in candidate.communityServices">
                                        <td scope="col">({{ communityServiceIndex + 1 }})</td>
                                        <td scope="col" class="text-break">{{ communityService.data }}</td>
                                        <td scope="col" style="width: 180px">
                                            <div class="spinnersession"
                                                v-if="communityServiceScoring && (itemToScore == communityServiceIndex || itemToScore == 'all')">
                                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            </div>
                                            <div class="text-end">
                                                <span v-if="!communityServiceScoring">
                                                    <span class="mt-1">
                                                        {{ communityService.sessionNum }} session(s)
                                                    </span>
                                                    &nbsp;
                                                    <span class="mt-1">
                                                        x
                                                    </span>
                                                    &nbsp;
                                                    <select class="score"
                                                        v-model="candidate.communityServices[communityServiceIndex].score"
                                                        @change="scoreItem('communityServices', communityServiceIndex, $event.target.value)">
                                                        <option value=0 selected>0</option>
                                                        <option value=1>1</option>
                                                        <option value=2>2</option>
                                                        <option value=3>3</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#otherinfo" aria-expanded="true" aria-controls="collapseOne">
                            <b>H. &nbsp; &nbsp;  OTHER RELEVANT INFORMATION</b>
                        </button>
                    </h2>
                    <div id="otherinfo" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="row">H.1</th>
                                        <td colspan="3"><b>State any significant experience
                                                gained during the reporting period:
                                            </b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.experienceGained }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">H.2</th>
                                        <td colspan="3"><b>Describe any University activities (BCDEF & G) above
                                                you think you excelled in during the reporting period:
                                            </b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.serviceExcelledIn }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">H.3</th>
                                        <td colspan="3"><b>Were there any University activities (BCDEF & G)
                                                above you performed not very satisfactorily?
                                            </b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.unsatisfactoryActivities }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">H.4</th>
                                        <td colspan="3"><b>If so, please explain the reasons:</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.unsatisfactoryActivitiesReasons }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="col">H.5</th>
                                        <th scope="col" colspan="5">National and International Award:</th>
                                    </tr>
                                    <tr v-for="award, awardIndex in candidate.academicStaff.awards">
                                        <td scope="col">({{ awardIndex + 1 }})</td>
                                        <td scope="col" colspan="3" class="text-break">{{ award.data }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!certifierIsExternal">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#relations" aria-expanded="true" aria-controls="collapseOne">
                            <b>I. &nbsp; &nbsp;  HUMAN RELATIONS</b>
                        </button>
                    </h2>
                    <div id="relations" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3"><b>How would you describe your relationship with:
                                            </b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td colspan="3"><b>Your Senior Officer?</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.seniorOfficerRelationship }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td colspan="3"><b>Your Colleagues?</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.colleaguesRelationship }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td colspan="3"><b>Staff Working under you?</b></td>
                                    </tr>
                                    <tr>
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.subordinateRelationship }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="accordion-item" v-if="!token">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#certification" aria-expanded="true" aria-controls="collapseOne">
                            <b>J. &nbsp; &nbsp;  CERTIFICATION</b>
                        </button>
                    </h2>
                    <div id="certification" class="accordion-collapse collapse" >
                        <div class="accordion-body">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <th scope="row">J</th>
                                        <td colspan="3"><b>Comments/Confirmation made by Head of Department on claims made by
                                                staff:
                                            </b></td>
                                    </tr>
                                    <tr v-if="candidate.hodComments">
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.hodComments.claimsVerification }}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">K</th>
                                        <td colspan="3" class="text-break"><b>General Comments/Assessment by Head of Department:</b></td>
                                    </tr>
                                    <tr v-if="candidate.hodComments">
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.hodComments.comment }}</td>
                                    </tr>
                                    <tr v-if="candidate.hodComments">
                                        <th scope="row"></th>
                                        <td colspan="3">{{ candidate.hodComments.date}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th scope="row">L</th>
                                        <td colspan="3"><b>Comments by Dean/Director/Librarian (include confirmation whether
                                                adverse comments on staff, if any have been communicated to the staff concerned):</b>
                                        </td>
                                    </tr>
                                    <tr v-if="candidate.deanComments">
                                        <th scope="row"></th>
                                        <td colspan="3" class="text-break">{{ candidate.deanComments.comment }}</td>
                                    </tr>
                                    <tr v-if="candidate.deanComments">
                                        <th scope="row"></th>
                                        <td colspan="3">{{ candidate.deanComments.date}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container my-4 card" v-if="token && certifierIsHOD && !candidate.submitted">
                <div class="card-body">
                    <div class="card-title mb-3"><h4><b>HOD CERTIFICATION</b></h4></div>
                    <div class="mb-3">
                        <label for="hodName">
                            <b>Name of HOD:</b>
                        </label>
                        <input v-model="hodName" type="text" class="form-control" id="hodName">
                    </div>
                    <div>
                        <label for="claimsVerification">
                            <b>Comments/Confirmation made by Head of Department on claims made by staff:</b>
                        </label>
                        <textarea v-model="claimsVerification" type="text" class="form-control" id="claimsVerification"></textarea>
                    </div>

                    <div class="my-3">
                        <label for="hodComments">
                            <b>General Comments/Assessment by Head of Department:</b>
                        </label>
                        <textarea v-model="hodComments" type="text" class="form-control" id="hodComments"></textarea>
                    </div>
                </div>
                <div class="text-start mb-3 ms-3">
                    <div class="form-check mb-4">
                        <input v-model="hodApproval" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" :value=false>
                        <label class="form-check-label" for="flexRadioDefault1">
                            <h6><b>I don't approve Staff to submit to the Dean.</b></h6>
                            <small>Staff will be asked to make corrections and resubmit to the HOD.</small>
                        </label>
                    </div>
                    <div class="form-check">
                        <input v-model="hodApproval" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" :value=true>
                        <label class="form-check-label" for="flexRadioDefault2">
                            <h6><b>I approve Staff to submit to the Dean.</b></h6>
                            <small>Staff will be allowed to submit to the Dean.</small>
                        </label>
                    </div>
                </div>
                <div class="my-3 d-flex justify-content-center">
                    <button @click="submitComments('hod')" type="button" class="btn btn-success">Submit Comments</button>
                </div>
            </div>

            <div class="container my-4 card" v-if="token && certifierIsDean && !candidate.submitted">
                <div class="card-body">
                    <div class="card-title mb-3"><h4><b>DEAN CERTIFICATION</b></h4></div>
                    <div class="mb-3">
                        <label for="deanName">
                            <b>Name of Dean:</b>
                        </label>
                        <input v-model="deanName" type="text" class="form-control" id="deanName">
                    </div>
                    <div>
                        <label for="deanComments">
                            <b>Comments by Dean/Director/Librarian (include confirmation whether adverse comments on staff, if any have been communicated to the staff concerned):</b>
                        </label>
                        <textarea v-model="deanComments" type="text" class="form-control" id="deanComments"></textarea>
                    </div>
                </div>
                <div class="text-start mb-3 ms-3">
                    <div class="form-check mb-4">
                        <input v-model="deanApproval" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" :value=false>
                        <label class="form-check-label" for="flexRadioDefault1">
                            <h6><b>I don't approve Staff for final submission.</b></h6>
                            <small>Staff will be asked to make corrections and resubmit to the Dean.</small>
                        </label>
                    </div>
                    <div class="form-check">
                        <input v-model="deanApproval" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" :value=true>
                        <label class="form-check-label" for="flexRadioDefault2">
                            <h6><b>I approve Staff for final submission.</b></h6>
                            <small>Staff will be allowed to submit application for appraisal.</small>
                        </label>
                    </div>
                </div>
                <div class="my-3 d-flex justify-content-center">
                    <button @click="submitComments('dean')" type="button" class="btn btn-success">Submit Comments</button>
                </div>
            </div>

            <div class="mt-4 ms-4 d-flex" v-if="certifierIsAssessor || certifierIsPanel">
                <span>
                    <b>Bonus:</b> &nbsp;
                </span>
                <span style="width: 100px;">
                    <input type="number" class="form-control" v-model="candidate.bonus" @change="scoreItem('bonus', '', candidate.bonus)" :disabled="certifierIsPanel">
                </span>
            </div>

            <div class="my-3 d-flex justify-content-center" style="margin: 50px 10px !important;">
                <router-link :to="'/result/' + candidate._id + '?token=' + $route.query.token">
                    <button type="button" class="btn btn-success">View Result</button>
                </router-link>
            </div>

        </div>
    </div>
</template>
<script>
import DataService from '../../services/dataservice';
import socket from '../../services/socket'

export default {
    name: 'candidate',
    emits: ['toggleLoader'],
    data() {
        return {
            candidate: {
                academicStaff: {},
                bonus: 0
            },
            hodName: '',
            claimsVerification: '',
            hodComments: '',
            hodApproval: '',
            deanName: '',
            deanComments: '',
            deanApproval: '',
            itemToScore: ''
        }
    },
    computed: {
        token() {
            return this.$route.query.token ? this.$route.query.token == 'undefined' ? false : true : false;
        },
        certifierIsDean() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'dean'
            } else {
                return false
            }
        },
        certifierIsHOD() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'hod'
            } else {
                return false
            }
        },
        certifierIsAssessor() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'assessor'
            } else {
                return false
            }
        },
        certifierIsPanel() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'panel'
            } else {
                return false
            }
        },
        certifierIsExternal() {
            if (this.$route.query.token && this.$route.query.token != 'undefined') {
                var payload = this.$route.query.token.split('.')[1]
                return JSON.parse(atob(payload)).certifier == 'external'
            } else {
                return false
            }
        }
    },
    async created() {
        await this.setData();
        socket.on(this.candidate._id, (candidate) => {
            if (candidate) {
                if (this.certifierIsAssessor) {
                    this.candidate = candidate.submittedDoc;
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var email = JSON.parse(atob(payload)).email

                    if (candidate.presentStatus == 'Senior Lecturer') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].email == email) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].email == email) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                }
            }
        })
    },
    methods: {
        async scoreItem(item, index, score) {
            this.$emit('toggleLoader');

            var scoreDetails = {
                candidateId: this.$route.params.id,
                item: item,
                index: index,
                score: score,
                token: this.$route.query.token
            }

            var candidate = await DataService.scoreItem(scoreDetails);

            if (candidate) {
                if (this.certifierIsHOD || this.certifierIsDean || !this.token) {
                    this.candidate = candidate;
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var email = JSON.parse(atob(payload)).email

                    if (candidate.presentStatus == 'Senior Lecturer') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].email == email) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].email == email) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                } else {
                    this.candidate = candidate.submittedDoc;
                }
            }

            this.$emit('toggleLoader');
        },
        async submitComments(certifier){
            this.$emit('toggleLoader');

            if (certifier == 'hod') {
                if (this.hodName) {
                    if (this.claimsVerification && this.hodComments && (this.hodApproval !== '')) {
                        const date = new Date();

                        var commentDetails = {
                            candidateId: this.$route.params.id,
                            token: this.$route.query.token,
                            hodComments: { 
                                name: this.hodName,
                                claimsVerification: this.claimsVerification,
                                comment: this.hodComments,
                                approval: this.hodApproval, 
                                date: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear() 
                            }
                        }

                        const res = await DataService.submitComments(commentDetails);

                        if (res) {
                            alert('Successfully saved. The candidate will be notified.');
                            this.$router.push({ path: '/' })
                        }
                    } else {
                        alert('Please certify and comment on the candidate')
                    }
                } else {
                    alert('Please fill in the name of the HOD')
                }
            }

            if (certifier == 'dean') {
                if (this.deanName) {
                    if (this.deanComments && (this.deanApproval !== '')) {
                        const date = new Date();

                        var commentDetails = {
                            candidateId: this.$route.params.id,
                            token: this.$route.query.token,
                            deanComments: { 
                                name: this.deanName,
                                comment: this.deanComments,
                                approval: this.deanApproval, 
                                date: date.getUTCDate() + '/' + (Number(date.getUTCMonth()) + 1) + '/' + date.getUTCFullYear() 
                            }
                        }

                        const res = await DataService.submitComments(commentDetails);

                        if (res) {
                            alert('Successfully saved. The candidate will be notified.');
                            this.$router.push({ path: '/' })
                        }
                    } else {
                        alert('Please certify and comment on the candidate')
                    }
                } else {
                    alert('Please fill in the name of the Dean')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(this.$route.params.id)

            if (candidate) {
                if (this.certifierIsHOD || this.certifierIsDean || !this.token) {
                    this.candidate = candidate;
                } else if (this.certifierIsExternal) {
                    var payload = this.$route.query.token.split('.')[1]
                    var email = JSON.parse(atob(payload)).email

                    if (candidate.presentStatus == 'Senior Lecturer') {
                        for (var i=0; i < candidate.readerExternalAssessors.length; i++) {
                            if (candidate.readerExternalAssessors[i].email == email) {
                                this.candidate = candidate.readerExternalAssessors[i].candidate
                            }
                        }
                    } else if (candidate.presentStatus == 'Reader') {
                        for (var i=0; i < candidate.profExternalAssessors.length; i++) {
                            if (candidate.profExternalAssessors[i].email == email) {
                                this.candidate = candidate.profExternalAssessors[i].candidate
                            }
                        }
                    }
                } else {
                    this.candidate = candidate.submittedDoc;
                }
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>